import { Instance, types } from 'mobx-state-tree';

const Flags = types.model({
  isRequesting: false,
});

export interface FlagsStore extends Instance<typeof Flags> {}
export default Flags;
